import { Pipe, PipeTransform } from '@angular/core';
import { eProductStatus } from 'src/app/models/eProductStatus';

@Pipe({
	name: 'productStatus'
})
export class ProductStatusPipe implements PipeTransform {

	transform(status:eProductStatus, gender:"f"|"m" = "m") : string {
		switch (status) {
			case eProductStatus.DRAFT : {
				return "Borrador";
			}
			case eProductStatus.ACTIVE : {
				return (gender == "m") ? "Activo" : "Activa";
			}
			case eProductStatus.INACTIVE : {
				return (gender == "m") ? "Inactivo" : "Inactiva";
			}
			default : {
				throw new Error("Invalid status "+ status);
			}
		}
	}

}
